import NavAccordion from '../../components/NavAccordion';
import NavGroup from '../../components/NavGroup';
import { BiUnite } from 'react-icons/bi';
import { FaBars, FaUserCog, FaUserFriends } from 'react-icons/fa';
import { SiChatbot } from 'react-icons/si';
import { HiDocumentReport } from 'react-icons/hi';
import { useState } from 'react';
import IconWrapper from '../../components/IconWrapper';
import { Unit } from '../../commons/interfaces/unit.interface';
import useAuth from '../../hooks/auth.hook';
import useUnit from '../../hooks/unit.hook';
import logo from '../../images/main-logo-white.png';
import './style.css';

export default function SideBar() {
  const { user } = useAuth();
  const { units } = useUnit();
  const [showText, setActive] = useState(true);

  const handleActive = () => {
    setActive(!showText);
  };

  return (
    <div
      className="sidebard d-flex flex-column flex-shrink-0 p-3 text-white bg-primary min-vh-100"
      style={{ width: showText ? '300px' : 'auto' }}>
      <div className="logo d-flex gap-3 nav-link no-hover">
        <div onClick={handleActive} className="cursor-pointer">
          <IconWrapper size={23} color="text-white">
            <FaBars />
          </IconWrapper>
        </div>
        {showText && (
          <a href="/" className="text-white text-decoration-none">
            <img className="main-logo" src={logo} alt="Votorantim" />
          </a>
        )}
      </div>
      <hr />
      <NavGroup>
        <NavGroup.Item
          to="/managers"
          icon={<FaUserCog />}
          showText={showText}
          disabled={user?.role !== 'ADMIN'}>
          Gestión de usuario
        </NavGroup.Item>
        <NavGroup.Item
          to="/chatbot/data"
          icon={<BiUnite />}
          showText={showText}
          disabled={user?.role !== 'ADMIN'}>
          Chatbot Conocimiento
        </NavGroup.Item>
        <NavGroup.Item to="/businesses" icon={<FaUserFriends />} showText={showText}>
          Gestión de contratista
        </NavGroup.Item>
        <NavAccordion menuActive={showText}>
          <NavAccordion.Header icon={<SiChatbot />} showText={showText}>
            Atención chatbot
          </NavAccordion.Header>
          <NavGroup>
            {units.map((unit: Unit) => (
              <NavGroup.Item key={unit.id} to={`/chatbot/${unit.id}/tickets`} icon={<BiUnite />}>
                {unit.name}
              </NavGroup.Item>
            ))}
          </NavGroup>
        </NavAccordion>
        {/* <NavGroup.Item to="/forms" icon={<FaFileAlt />} showText={showText}>
          Solicitudes de formulario
        </NavGroup.Item> */}
        <NavAccordion menuActive={showText}>
          <NavAccordion.Header icon={<HiDocumentReport />} showText={showText}>
            Reportes
          </NavAccordion.Header>
          <NavGroup>
            <NavGroup.Item to={'/reports/tickets'} icon={<BiUnite />}>
              Tickets
            </NavGroup.Item>
            {/* <NavGroup.Item to={'/reports/forms'} icon={<BiUnite />}>
              Formularios
            </NavGroup.Item> */}
            <NavGroup.Item to={'/reports/conversations'} icon={<BiUnite />}>
              Conversaciones
            </NavGroup.Item>
          </NavGroup>
        </NavAccordion>
      </NavGroup>
    </div>
  );
}
